import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icon/arrow.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icon/bank.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icon/simle.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/icon/StarFour.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/Covered.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/FAQ.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/Favourites.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/ScrollAnimation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/home/Search.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/Testimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/redirect_btn/SearchRedirectBtn.tsx");
